import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useBoolean } from '../../hooks/useBoolean'

export default function ClickAway({ onClickOutside, children }) {
  const ref = useRef()
  const [listen, { on, off }] = useBoolean()

  useEffect(() => {
    const clickHandler = (event) => {
      if (ref.current?.contains?.(event.target)) {
        on()
      }

      if (listen && !ref.current?.contains?.(event.target)) {
        onClickOutside()
        off()
      }
    }

    document.addEventListener('click', clickHandler, true)
    return () => {
      document.removeEventListener('click', clickHandler, true)
    }
  }, [listen, on, off, onClickOutside])

  return React.cloneElement(children, { ref: ref })
}

ClickAway.propTypes = {
  children: PropTypes.node.isRequired,
  onClickOutside: PropTypes.func.isRequired
}
